<template>
  <div class="registration-container">
    <div class="form-box">
      <div class="form-item flex justify-between">
        <div class="label font-color3">{{ locale.localeProp('reg-deadline') }}</div>
        <div class="value font-color1">{{ regEndDate }}</div>
      </div>
      <div class="form-item flex justify-between">
        <div class="label font-color3">{{ locale.localeProp('reg-fee') }}</div>
        <div class="value font-color1">{{ info.price }}</div>
      </div>
      <div class="form-item flex justify-between">
        <div class="label font-color3">{{ locale.localeProp('reg-groups') }}</div>
        <div class="value font-color1 overflow-text-tow">{{ info.groupsName }}</div>
      </div>
    </div>
    <div class="button-box" @click="goGroupList">
      <div class="button text-center color-white" :class="{ 'button--before': regStatus === 'before' }">{{ regButtonText }}</div>
    </div>
  </div>
</template>

<script>
// 赛事报名
import { Toast } from 'vant'
import NewMatchDetail from '@/tbs/model/to/NewMatchDetail'
import DateTimeFunc from '@/tbs/util/DateTimeFunc'

export default {
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      locale: new NewMatchDetail
    }
  },
  computed: {
    /** 报名状态：before 报名前 / during 报名中 / after 报名后 */
    regStatus() {
      const begin = this.info.regBeginDate
      const end = this.info.regEndDate
      if (!begin || !end) return 'after'
      const now = Date.now()
      const beginTime = new Date(begin).getTime()
      const endTime = new Date(end).getTime()
      if (isNaN(beginTime) || isNaN(endTime)) return 'after'
      if (now < beginTime) return 'before'
      if (now <= endTime) return 'during'
      return 'after'
    },
    /** 按钮文案：报名前=开始时间+开启报名，报名中=立即查看，报名后=查看报名 */
    regButtonText() {
      const status = this.regStatus
      if (status === 'before') {
        const begin = this.info.regBeginDate
        const formatted = begin ? DateTimeFunc.formatFullDate(new Date(begin), 'yyyy-mm-dd hh:mm') : ''
        return (formatted ? formatted + ' ' : '') + this.locale.localeProp('reg-open-at')
      }
      if (status === 'during') return this.locale.localeProp('reg-view-now')
      return this.locale.localeProp('reg-view')
    },
    regEndDate() {
      return this.info.regEndDate ? DateTimeFunc.formatFullDate(new Date(this.info.regEndDate), 'yyyy-mm-dd hh:mm') : ''
    }
  },
  methods: {
    goGroupList() {
      const status = this.regStatus
      if (status === 'before') {
        const begin = this.info.regBeginDate
        const formatted = begin ? DateTimeFunc.formatFullDate(new Date(begin), 'yyyy-mm-dd hh:mm') : ''
        const tip = this.locale.localeProp('reg-start-time-tip') + (formatted || '')
        Toast(tip)
        return
      }
      if (!this.info.unionMatchId) return
      if (status === 'during') {
        this.$router.push({
          path: '/entry-page/project-list',
          query: { unionMatchId: this.info.unionMatchId }
        })
      } else {
        this.$router.push({
          path: '/entry-page/entry-list',
          query: { unionMatchId: this.info.unionMatchId }
        })
      }
    }
  }
}
</script>
<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.registration-container {
  .form-item { margin-top: 14px; align-items: flex-start; }
  .label { font-size: 13px; }
  .value { font-size: 15px; max-width: 240px;text-align: right; }
  .button-box {
    padding: 0 6px;
    .button {
      height: 40px;
      background-color: #C45656;
      border-radius: 5px;
      font-size: 13px;
      line-height: 40px;
      margin-top: 14px;
      &.button--before { background-color: #C7C9CC; }
    }
  }
}
</style>
